import Car1Img from '../assets/images/Cars/Fabia-min.JPG'
import Car2Img from '../assets/images/Cars/Rapid černý-min.JPG'
import Car3Img from '../assets/images/Cars/Rapid modrý-min.JPG'
import Car4Img from '../assets/images/Cars/Yeti automat-min.JPG'
import ZaciImg from '../assets/images/Other/Zaci.jpg'
import Zaci2Img from '../assets/images/Other/Zaci2.jpg'
import ZakImg from '../assets/images/Other/Zak.jpg'
import KTMDukeImg from '../assets/images/Cars/KTM Duke 125.jpg'
import HondaCB125RImg from '../assets/images/Cars/Honda CB125R.jpg'
import CFMoto300NKImg from '../assets/images/Cars/CF MOTO 300NK.jpg'
import HondaCB500Img from '../assets/images/Cars/Honda CB500 Hornet.jpg'
import HondaCB750Img from '../assets/images/Cars/Honda CB750 Hornet.jpg'
import { Carousel } from 'flowbite-react'

const Carusel = () => {
    return (
        <div className=' h-[18rem] md:h-[30rem]'>
            <Carousel>
                <img src={Car1Img} loading='lazy' alt='Škoda Fabia - cvičné vozidlo autoškoly' className='w-full' />
                <img src={Car2Img} loading='lazy' alt='Škoda Rapid černý - cvičné vozidlo autoškoly' className='w-full' />
                <img src={Car3Img} loading='lazy' alt='Škoda Rapid modrý - cvičné vozidlo autoškoly' className='w-full' />
                <img src={Car4Img} loading='lazy' alt='Škoda Yeti s automatickou převodovkou' className='w-full' />
                <img src={KTMDukeImg} loading='lazy' alt='KTM Duke 125' className='w-full' />
                <img src={HondaCB125RImg} loading='lazy' alt='Honda CB125R' className='w-full' />
                <img src={CFMoto300NKImg} loading='lazy' alt='CF MOTO 300NK' className='w-full' />
                <img src={HondaCB500Img} loading='lazy' alt='Honda CB500 Hornet' className='w-full' />
                <img src={HondaCB750Img} loading='lazy' alt='Honda CB750 Hornet' className='w-full' />
                <img src={ZaciImg} loading='lazy' alt='Úspěšní absolventi autoškoly Erko' className='w-full' />
                <img src={Zaci2Img} loading='lazy' alt='Studenti autoškoly Erko' className='w-full' />
                <img src={ZakImg} loading='lazy' alt='Student při praktické výuce' className='w-full object-cover' />
            </Carousel>
        </div>
    )
}

export default Carusel
